import { bossWebAxios } from '../api';
import { moduleNameMap } from '../config';

const { MARKETZONE_BOSS } = moduleNameMap;

/**
 * 获取中台 market-zone 的所有枚举
 * @param {*} params
 * @param {*} config
 * @returns
 */
export const enumsAllGet = (params, config) => bossWebAxios(params, `${MARKETZONE_BOSS}/enum/enums/all/get.do`, config);
